import { useTheme } from '@emotion/react'

export const AppleIcon = () => {
  const theme = useTheme()

  return (
    <svg viewBox="0 0 26 30" xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem">
      <path
        d="M25.077 9.846c-2.27 1.607-3.406 3.54-3.406 5.801 0 2.707 1.403 4.784 4.209 6.232-.754 2.181-1.844 4.08-3.272 5.697C21.18 29.192 19.876 30 18.696 30c-.555 0-1.314-.183-2.276-.55l-.46-.179c-.943-.367-1.776-.55-2.5-.55-.684 0-1.432.144-2.245.431l-.58.208-.73.298a4.687 4.687 0 01-1.74.342c-1.378 0-2.9-1.135-4.566-3.406C1.2 23.342 0 19.797 0 15.959c0-2.726.749-4.923 2.246-6.589 1.497-1.665 3.48-2.498 5.95-2.498.922 0 1.784.168 2.587.505l.55.223.58.238c.516.219.933.328 1.25.328.407 0 .858-.095 1.354-.283l.758-.297.565-.209c.903-.327 1.9-.49 2.99-.49 2.588 0 4.67.986 6.247 2.96zM18.949 0c.03.347.045.615.045.803 0 1.716-.625 3.22-1.875 4.514-1.249 1.294-2.702 1.941-4.357 1.941a7.473 7.473 0 01-.075-.833c0-1.457.58-2.826 1.74-4.105 1.16-1.279 2.504-2.027 4.031-2.246.11-.02.273-.044.49-.074z"
        fill={theme.arcadeColors.semantic.iconInverse}
        fillRule="evenodd"
      />
    </svg>
  )
}
